module.exports = __webpack_public_path__ + "img/dante.b1cb730b.svg";